import { Chip } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { camelCaseToSentenceCase } from "../../../helpers/camelCaseToSentenceCase";

export type MaintenanceStatus = "overdue" | "overdueSoon";

export const statusColors: Record<
  MaintenanceStatus,
  {
    label: string;
    color:
      | "default"
      | "primary"
      | "secondary"
      | "error"
      | "info"
      | "success"
      | "warning";
  }
> = {
  overdue: { label: "Overdue", color: "error" },
  overdueSoon: { label: "Overdue Soon", color: "warning" },
};

export const maintenanceTableColumns: GridColDef[] = [
  { field: "unitNumber", headerName: "Unit Number", width: 300 },
  {
    field: "operationPerformed",
    headerName: "Operation Performed",
    width: 350,
    valueFormatter: (value) => camelCaseToSentenceCase(value as string),
  },
  { field: "dueIn", headerName: "Due In", width: 300 },
  {
    field: "status",
    headerName: "Status",
    width: 250,
    renderCell: (params) => (
      <Chip
        label={statusColors[params.value as MaintenanceStatus].label}
        color={statusColors[params.value as MaintenanceStatus].color}
      />
    ),
  },
];
